<template>
    <div>
        <TheBanner :title="this.$lang.downloadsTitle"
                   :description="this.$lang.downloadsSubtitle"
                   image="cover.jpeg"/>
        <ListView :data="downloads"
                  id="grid"
                  type="pop"
                  class="body-block"/>
    </div>
</template>

<script>
	import TheBanner from "@/components/TheBanner";
	import ListView from "@/components/ListView";
	import DownloadService from "@/services/DownloadService";

	export default {
		name: "Downloads",
		components: {ListView, TheBanner},
		created() {
			DownloadService.getDownloads().then(result => {
				this.downloads = result;
			})
		},
		data() {
			return {
				downloads: []
			};
		}
	}
</script>

<style scoped lang="scss">
    #grid {
        @media #{$tablet} {
            margin-top: 16px;
        }

        @media #{$tablet-inv} {
            margin-top: 48px;
        }
    }

    #grid::v-deep .button {
        text-align: left;
    }
</style>